import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="relative flex flex-col items-center justify-center h-screen text-center px-4 bg-background-50">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-100 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <h2 className="text-xl md:text-2xl font-semibold mt-6 text-foreground-900">This page has not been generated</h2>
        <p className="mt-2 text-base text-foreground-500 font-mono">The page you are looking for does not exist.</p>
        <p className="mt-4 text-lg md:text-xl text-foreground-600">Return to the homepage to continue exploring BaseTao Spreadsheet resources.</p>
        <Link
          to="/"
          className="inline-block mt-6 px-6 py-3 rounded-xl bg-primary-500 text-white hover:bg-primary-600 text-sm font-semibold transition-colors cursor-pointer"
        >
          Back to Homepage
        </Link>
      </div>
    </div>
  );
}